/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BindingEnergy
 */
export interface BindingEnergy {
    /**
     * 
     * @type {number}
     * @memberof BindingEnergy
     */
    wt: number;
    /**
     * 
     * @type {number}
     * @memberof BindingEnergy
     */
    mut: number;
    /**
     * 
     * @type {number}
     * @memberof BindingEnergy
     */
    diff: number;
}

/**
 * Check if a given object implements the BindingEnergy interface.
 */
export function instanceOfBindingEnergy(value: object): value is BindingEnergy {
    if (!('wt' in value) || value['wt'] === undefined) return false;
    if (!('mut' in value) || value['mut'] === undefined) return false;
    if (!('diff' in value) || value['diff'] === undefined) return false;
    return true;
}

export function BindingEnergyFromJSON(json: any): BindingEnergy {
    return BindingEnergyFromJSONTyped(json, false);
}

export function BindingEnergyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BindingEnergy {
    if (json == null) {
        return json;
    }
    return {
        
        'wt': json['wt'],
        'mut': json['mut'],
        'diff': json['diff'],
    };
}

export function BindingEnergyToJSON(json: any): BindingEnergy {
    return BindingEnergyToJSONTyped(json, false);
}

export function BindingEnergyToJSONTyped(value?: BindingEnergy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'wt': value['wt'],
        'mut': value['mut'],
        'diff': value['diff'],
    };
}

